import React, { useCallback } from "react";
import { Box } from "@shopify/polaris";

export default function EditorContent({ disabled, children }: {
  readonly disabled: boolean;
  readonly children: React.ReactNode;
}): React.JSX.Element {
  const setElement = useCallback((element: HTMLDivElement | null): void => {
    if (element) element.inert = disabled;
  }, [disabled]);

  return <Box ref={setElement}>{children}</Box>;
}
